import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  async copyToClipboard(text: string, type: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(text);
      this.showToast(`${type} copied to clipboard`);
    } catch (err) {
      console.error('Error copying to clipboard:', err);
      // Fallback for older browsers
      this.fallbackCopyTextToClipboard(text, type);
    }
  }

  // Fallback for browsers that do not support navigator.clipboard
  private fallbackCopyTextToClipboard(text: string, type: string): void {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this.showToast(`${type} copied to clipboard`);
      } else {
        console.error('Fallback: Unable to copy text');
      }
    } catch (err) {
      console.error('Fallback: Error copying text', err);
    }

    document.body.removeChild(textArea);
  }

  // Function to initiate a phone call
  makePhoneCall(phoneNumber: string): void {
    window.location.href = `tel:${phoneNumber}`;
  }

  // Function to open email client
  sendEmail(email: string): void {
    window.location.href = `mailto:${email}`;
  }

  // Function to show toast/notification
  private showToast(message: string): void {
    const toast = document.createElement('div');
    toast.className = 'toast-notification';
    toast.textContent = message;
    
    toast.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background-color: #086AD8;
      color: white;
      padding: 12px 20px;
      border-radius: 5px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 9999;
      font-size: 14px;
      opacity: 0;
      transform: translateY(-20px);
      transition: all 0.3s ease;
    `;

    document.body.appendChild(toast);

    setTimeout(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateY(0)';
    }, 100);

    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(-20px)';
      setTimeout(() => {
        if (document.body.contains(toast)) {
          document.body.removeChild(toast);
        }
      }, 300);
    }, 3000);
  }
}
